module.exports = {
  "CS_info2_Network_Image_HvHe": "ウェブサイト上の画像",
  "CS_one_Batch_configuration_Ffmp": "バッチの構成",
  "CS_5_When_the_PbND": "このインバウンド ユーザーは乗客です。乗客のツールのみ使用できます。",
  "CS_one_Scenario_ENG_mFbn": "シナリオ (ja_JP)",
  "CS_info_Comments_failed_mQNX": "コメントを追加できませんでした",
  "CS_5_Do_not_kYRj": "上限回数を超えました",
  "CS_2_It_is_vdcu": "まず先にIN-APPメッセージで返信してください（同時にメール通知も送信されます）。やり方がわからない場合は、上司に確認してください。",
  "CS_1_Template_oNtV": "テンプレート",
  "CS_tickets_User_Type_Wdya": "ユーザータイプ",
  "CS_info2_Please_fill_uLvw": "入力してください",
  "CS_one_Operation_Log_hsdo": "操作ログ",
  "CS_one_Tips_vbZx": "注意",
  "CS_one_Upload_successfully_DliZ": "ファイルが正常にアップロードされました。作成が済むと、対象国で有効になります。該当する国の関係する同僚に知らせてください。",
  "CS_info2_Cancel_link_vxaa": "リンクを削除",
  "CS_1_Action_pnrH": "アクション",
  "CS_pop_The_conversation_dKAF": "通話開始時間",
  "CS_one_Upload_files_TzsC": "ファイルをアップロード",
  "CS_1_Operational_results_nOpZ": "操作の結果",
  "CS_one_Please_check_SuZo": "2.記入済のテンプレートをアップロードします(アップロード前にすべての項目が正しく記入されていることを確認してください)。",
  "CS_1_Temporary_CTPp": "一時保存",
  "CS_1_Solved_ooGh": "解決済み",
  "CS_page_Unable_to_aXip": "チケットを作成できませんでした",
  "CS_one_Enter_rfGy": "入力してください",
  "CS_1_Message_Title_AJzH": "Eメールタイトル",
  "CS_2_Worksheet_ID_SxiT": "チケットIDはチケット作成時に生成されます",
  "CS_2_Copy_the_hSGF": "携帯電話番号がコピーされました。この操作は記録されています。会社の情報セキュリティポリシーに従ってください。",
  "CS_one_Classification_of_qEgR": "コンタクトリーズンの管理",
  "ark.global.cs.field.values.ticket_tab_im": "チャット",
  "CS_qa_This_behavior_dZrQ": "このページでの操作はログされています。会社の情報セキュリティポリシーに従ってください。",
  "CS_Page_Driver_List_Uxwj": "ドライバーリスト",
  "CS_1_Thank_you_WUlL": "フィードバックありがとうございます。",
  "CS_info_Select_Question_QkZC": "問い合わせ理由を選択してください",
  "CS_5_Your_query_uvJB": "クエリ―の上限に達しました",
  "CS_one_Determination_GUbi": "OK",
  "CS_buchong_eFit_JNbR": "注文情報が見つかりません。携帯電話番号が無効か、ユーザー登録されていません。",
  "CS_Page_Rider_Details_Ovwp": "乗客詳細：乗客ID",
  "CS_1_Amount_mYAW": "金額",
  "CS_Page_Order_Details_oAUq": "注文詳細：注文 ID",
  "CS_Adjustment_YdjN_bXSL": "SOPのスキップ理由が不十分です。別の理由を入力してください。",
  "CS_Adjustment_gjOY_YpxQ": "SOP情報がPCの情報と一致しません",
  "CS_buchong__yLly": "携帯電話番号が無効であるか、ユーザー登録がないため、ツールを使用できません。",
  "CS_Tools_1209_Optimus_Coupon_Inuquiry_Scope_of_bBLW": "乗客 ID ",
  "CS_one_Batch_effective_prPl": "バッチの認証",
  "CS_one_Country_and_Qyqv": "国および営業項目の設定",
  "CS_page_Please_fill_ikWU": "チケットグループを選択してください",
  "CS_tickets_Three_days_pcmE": "過去3日間",
  "CS_one_New_Batch_wEKW": "バッチの作成",
  "CS_one_Abandoned_ROgG": "破棄済み",
  "CS_1_Enter_content_haAO": "ここにテキストを入力",
  "CS_one_Description_ENG_vIZz": "詳細 (ja_JP)",
  "CS_page_Work_orders_MRDt": "チケットは正常にクローズされました",
  "CS_one_Translation_configuration_lnQZ": "翻訳設定",
  "CS_tickets_Compensation_deduction_GJfV": "補償/差し引き方法",
  "CS_info_Like_failure_mPup": "エラーが起きました。もう一度お試しください。",
  "CS_info2_Make_sure_zyfT": "このオプションを選択する前に、このチケットでは都市情報は使用できないことをご確認ください",
  "verify---id_no_co": "認証する",
  "CS_4_Topographic_tools_KqUl": "地図",
  "CS_Page_Driver_Type_UnIR": "ドライバーのタイプ",
  "CS_information_Order_Basis_WKGU": "注文の基本情報",
  "Magellan_improvement_The_company_CoIp": "インスタントメッセージおよび通話履歴は会社が所有する機密データです。情報保護規則に従って適切に取り扱ってください。すべての問い合わせはシステムによって記録されます。写真撮影、ダウンロードまたはこれらのデータを社外の第三者に開示することは固く禁じられています。",
  "CS_Page_Passenger_Details_vgGv": "乗客詳細ページ",
  "CS_pop_No_xtIB": "いいえ",
  "CS_pop_Cancel_byla": "キャンセル",
  "Magellan_improvement_IM_Information_weuP": "インスタントメッセージ情報",
  "CS_info2_Reset_Fiiu": "リセット",
  "CS_1_E_mail_rKAg": "Eメール",
  "CS_tickets_Administrator_BcHW": "マネージャー",
  "CS_one_Action_Type_uHTo": "操作タイプ",
  "Magellan_improvement_Question_description_GyVD": "問題の詳細",
  "CS_page_Do_you_UfOG": "{{ticketgroup}}にチケットを転送しますか？",
  "CS_page_Transportation_orders_UWhR": "チケットを転送",
  "CS_tickets_One_month_IrdR": "過去1ヵ月",
  "CS_5_Unchecked_user_vuUZ": "ユーザー登録情報が見つかりません",
  "CS_Settings_Countless_lEdc": "データがありません",
  "CS_page_Transferring_the_ZnkX": "チケットは正常に転送されました",
  "Magellan_improvement_Call_completed_hbKz": "通話完了",
  "CS_improvement_Passenger_JnXD": "乗客",
  "CS_Page_Driver_Basic_SItd": "基本ドライバー情報",
  "CS_one_Description_NrBC": "詳細",
  "CS_Adjustment_abEf_PYol": "SOPにバグがあります",
  "CS_4_Tools_can_ZQSK": "ツールはすべてCSシステムのチケット処理ページでのみ使用可能",
  "CS_one_Owner_EwUa": "オーナー",
  "CS_Page_Model_List_WVIO": "車種リスト",
  "CS_Page_Common_tools_FTJG": "共通ツール",
  "CS_info_Click_here_MKRf": "ここをクリックし、1つの注文に関連付け",
  "CS_thpoptimization__sSiH": "バンドル",
  "CS_3_Optional_kdMP": "任意",
  "CS_pop_User_Phone_hTGd": "ユーザーの電話番号",
  "CS_Page_City_name_atjF": "都市名",
  "CS_improvement_Call_SmCo": "通話日時",
  "CS_1_Comments_RcMN": "送信",
  "CS_info_This_page_Cpww": "システムラグを防ぐため、このページで開けるチケットタブは最大10です。必要のないタブを閉じてください。ご協力ありがとうございます。",
  "CS_tickets_Work_order_NQJE": "チケットのステータス",
  "CS_one_Entered_into_mEwl": "有効",
  "CS_Adjustment_txhj_lfbO": "続行するにはSOPの入力を行ってください",
  "CS_tickets_Three_months_Jdzc": "過去3ヵ月",
  "CS_1_Order_ID_bsCY": "注文ID",
  "CS_tool_Work_order_LjeC": "チケットのステータス",
  "CS_Page_Trip_Compl_Vcnk": "乗車終了時間",
  "CS_page_No_permissions_mYZG": "このチケットを転送する権限がありません",
  "CS_1_Send_email_DDPi": "Eメール送信を確定",
  "CS_buchong__BYdr": "携帯電話番号が無効であるか、ユーザーが未登録であるため、ユーザー情報の確認やダイナミックなアクセス制限の認証機能の使用はできません。",
  "CS_one_New_Problem_ORNp": "新規コンタクトリーズンの作成",
  "CS_Page_Select_the_kqHS": "フィルタ条件を選択してください",
  "CS_translation_Selection_of_yatg": "補償理由を選択してください",
  "CS_2_Please_select_Zapc": "選択してください",
  "CS_2_Refund_amount_ikWV": "払い戻し金額",
  "CS_Page_Enter_Order_TeQM": "注文ID を入力してください",
  "CS_Page_Type_SnKr": "モデル",
  "CS_QA1_More_than_uScx": "{{amount}}個以上のエントリーがある場合、{{amount}}個のみが表示されます。",
  "CS_one_Operation_Records_bTgJ": "操作ログ",
  "CS_1_ID_VNVI": "チケットID",
  "CS_pop_Bind_session_qEwk": "入電を関連付ける",
  "CS_info2_Jump_link_pUcH": "リダイレクト先",
  "CS_tickets_The_user_iVJx": "このユーザーはバンドルのマネージャーです（クリックして詳細を表示）",
  "ark.global.cs.field.values.ticket_tab_compensation": "記録の処理中",
  "CS_info2_Depositary_UmEY": "現在オーナー",
  "CS_initialization_Create_a_xRhB": "まずチケットを作成してください",
  "CS_pop_Bind_lDQM": "登録",
  "CS_Page_Order_List_IiWy": "注文リスト",
  "CS_one_Status_QWZW": "ステータス",
  "CS_information_Single_phone_vKdi": "注文者の電話番号",
  "CS_2_Driver_balance_otCh": "ドライバー残高からの差し引き",
  "CS_Notice_Please_submit_iVZB": "送信前に、このプロセスカードについてのフィードバックをお願いします",
  "CS_info2_Link_kBeS": "関連",
  "CS_1_You_do_Czvx": "お客様の個人情報を閲覧する権限がありません。システム認証を実行するか、管理者に問い合わせてください。",
  "CS_info_Process_cards_ccmd": "プロセスカード",
  "CS_improvement_The_main_DIgv": "発信者が電話を切った",
  "Help_2_More_OZUg": "もっと見る",
  "CS_1_Recipients_jNBa": "宛先",
  "CS_buchong1__XPiG": "動的認証が失敗したため、このアクションを実行できません。動的認証を完了するか、管理者にお問い合わせください。",
  "CS_Page_Enter_email_VDKC": "メールアドレスを入力",
  "CS_one_Return_axWQ": "戻る",
  "CS_tickets_Complaint_Manner_UWAQ": "関連者関連チケット",
  "CS_2_Refundable_mKnQ": "払い戻し対応可能？",
  "CS_pop_Whether_to_tvgd": "入電を関連付けずにチケットを作成しますか？",
  "CS_1_Send_an_oyHo": "このユーザーにEメールを送信してよろしいですか？",
  "CS_one_Upload_failed_tubs": "アップロードできませんでした。もう一度お試しください",
  "CS_tickets_Order_Work_UDue": "注文関連チケット",
  "Magellan_improvement_ID_HTMT": "チケットID",
  "CS_Page_Type_of_Chyl": "問い合わせのタイプ",
  "CS_initialization_Select_user_QGGG": "ユーザータイプを選択してください",
  "CS_improvement_Dial_man_vuMm": "発信者",
  "CS_one_Are_you_QXby": "本当にこのコンタクトリーズンを修正してよろしいですか？修正すると、新しいコンタクトリーズンが対象国で有効になります。該当する国の関係する同僚に知らせてください。",
  "CS_info2_Data_Not_mVCx": "データがありません",
  "CS_information_Purpose_tIXL": "目的地",
  "CS_Page_Response_mode_tfSQ": "応答モード",
  "CS_Page_Order_Status_ZJEQ": "注文ステータス",
  "CS_1_Internal_message_Dmzz": "内部メッセージ",
  "CS_1_More_online_ugOQ": "チャット履歴をさらに表示",
  "CS_one_1_Please_EOBr": "1.以下のテンプレートをダウンロードの上、記入をお願いします。",
  "CS_one_Applicable_States_HNdh": "対象国",
  "CS_translation_Submission_akuK": "送信",
  "CS_one_Basic_information_akKk": "基本情報",
  "CS_Page_Driver_Mobile_mQCL": "ドライバーの携帯電話番号",
  "CS_one_Father_classification_ZASx": "親カテゴリーレベル1 (ja_JP)",
  "CS_info_Select_user_WEYA": "問い合わせ理由を表示するため、ユーザータイプとサービスタイプを選択してください",
  "CS_information_Order_Status_ZZvi": "注文のステータス",
  "CS_Page_Please_choose_SkUr": "選択してください",
  "CS_one_Import_data_zhsI": "データをインポート",
  "CS_one_Applicable_Business_ERQA": "該当するビジネスタイプ",
  "CS_1_Off_aqDQ": "閉じる",
  "CS_info2__unk_MkzP": "画像のアップロード",
  "CS_qa_Successfully_saved_GaYt": "チケットが正常に保存されました",
  "CS_info2_User_Type_ylaU": "ユーザータイプ",
  "CS_1_Send_asynchronous_rowd": "IN-APPメッセージとメールを送信",
  "CS_1_Cancel_UVIs": "キャンセル",
  "CS_info2_link_Text_Gvnh": "関連情報",
  "CS_Page_Enter_Passenger_vcdv": "乗客IDを入力",
  "CS_one_Cancel_sSYi": "キャンセル",
  "CS_one_Add_VToU": "登録",
  "CS_one_Download_Template_XYvP": "テンプレートをダウンロードすることをお勧めします。",
  "CS_tickets_Compensation_Deducperiod_HFiB": "補償/差し引き実行時間",
  "CS_info2_Picture_text_mnMQ": "画像の詳細",
  "CS_1_User_Mobile_aNYY": "ユーザー携帯電話番号",
  "CS_Page_Product_line_gPCE": "プロダクトライン",
  "CS_info_There_is_vxeJ": "この問い合わせ理由にコンテンツがありません。詳細を確認のに、（ナレッジベース）をご参照ください",
  "CS_tickets_Today_klqB": "今日",
  "CS_tickets_Search_dVXa": "検索",
  "CS_improvement_Driver_ZOiL": "ドライバー",
  "CS_one_Scenarios_qeVe": "シナリオ",
  "CS_reconstruction_Determination_MvvP": "OK",
  "CS_2_Time_of_ynEo": "払い戻し日時",
  "CS_1_operator_gItF": "操作実行者：",
  "CS_info2_Image_address_QJoY": "画像URL",
  "CS_tickets_Type_of_DvxN": "チケットタイプ",
  "CS_tickets_Half_a_SjoS": "過去6ヵ月",
  "CS_info_Into_the_OLWz": "インバウンドユーザー[info]",
  "CS_page_Unable_to_sJgg": "チケットを解決できませんでした",
  "CS_1_Passengers_rXbp": "乗客",
  "CS_page_Unable_to_lQkV": "チケットをクローズできませんでした",
  "CS_1_Compensation_Deduction_eyNT": "補償/差し引き詳細",
  "CS_page_Unable_to_lWwm": "チケットを一時的に保存することはできませんでした",
  "CS_Page_Passenger_ID_WiFY": "乗客ID",
  "CS_Page_Clear_Query_qLSf": "検索条件をクリア",
  "CS_info2_View_link_fyZT": "リンクを表示",
  "CS_tickets_Work_order_STXN": "チケット履歴",
  "CS_2_Copy_successfully_rlpe": "正常にコピーされました",
  "CS_one_Grade_classification_sVNq": "親カテゴリー",
  "CS_Page_Driver_Details_Mnzk": "ドライバー詳細ページ",
  "CS_page_Successful_temporary_sFHU": "チケットは一時的に保存されました",
  "CS_page_Successfully_created_ffvZ": "チケットは正常に作成されました",
  "CS_Page_Purpose_rNGk": "降車地点",
  "CS_Tools_1231_Optimus_AdyenTool_Failure_TWRQ": "失敗",
  "CS_thpoptimization_Copy_the_CPlW": "メールアドレスがコピーされました。この操作は記録されています。会社の情報セキュリティポリシーに従ってください。",
  "CS_1_Status_of_Dkxj": "ステータス",
  "CS_Adjustment_VsHy_RwJo": "スキップする理由を入力してください",
  "CS_reconstruction_Select_Business_DYpG": "サービスタイプを選択してください",
  "CS_Settings_Can_not_wuTx": "必須入力項目です",
  "CS_1_Action_Name_sFel": "操作",
  "CS_Page_Driver_Details_uNcn": "ドライバー詳細：ドライバーID",
  "CS_pop_Action_zZIq": "アクション",
  "CS_pop_Confirmation_lTpQ": "はい",
  "CS_improvement_Phone_records_Kgdt": "通話履歴",
  "Help_buchong_Reply_RcHf": "返信",
  "CS_one_Classification_of_YYEd": "このコンタクトリーズン（CR）はセキュリティ関連ですか？",
  "CS_info2_Association_ZCdq": "関連付け",
  "CS_1_Work_orders_fADf": "内部メッセージがチケットに送信されました",
  "CS_qa_Collapse_DJRI": "表示を減らす",
  "CS_improvement_Voice_duration_TNdW": "通話時間",
  "CS_1_Work_order_pUHt": "Eメールがチケットに送信されました",
  "CS_1_Mail_address_Hxvv": "メールアドレス",
  "CS_Page_Driver_ID_HNzY": "ドライバーID",
  "CS_info_Select_a_CKYG": "都市を選択してください。選択可能な都市がない場合、「N/A」を選択してください",
  "Magellan_improvement_When_you_WyDX": "クローズすると注文は即座にキャンセルされます。慎重に選択してください。",
  "CS_tickets_Compensation_ID_PjEu": "補償ID",
  "CS_5_When_the_WPIZ": "このインバウンド ユーザーはドライバーです。ドライバーのツールのみ使用できます。",
  "CS_one_Please_confirm_BmHM": "選択されたコンタクトリーズンを確認してから、[確定]をクリックして認証してください。",
  "CS_1_Send_email_oriC": "Eメールを送信",
  "CS_tickets_One_week_YsBK": "過去1週間",
  "CS_page_Whether_the_pGhP": "このチケットは解決済みですか？確定すると、ステータスが「処理中」に変わります。",
  "CS_one_Off_Zqiv": "閉じる",
  "CS_2_For_security_YqmP": "安全上の理由のため、受信者のメールアドレスは非表示にされています。コミュニケーションには影響ありません。",
  "CS_info_Please_fill_yjjm": "携帯電話番号を入力してください",
  "CS_info2_Business_Type_KDsP": "サービスタイプ",
  "CS_1_Send_internal_kufI": "メッセージを送信",
  "CS_1_Save_dSGz": "保存",
  "CS_page_Priority_processor_Gwtc": "優先現在オーナー",
  "CS_1_The_author_xIBI": "送信者",
  "CS_one_Details_Page_mdDC": "コンタクトリーズンの詳細ページ",
  "CS_page_If_you_RZwt": "このチケットを一時的に保存しますか？これによってステータスは「一時保存済み」に変わります。",
  "CS_page_Work_order_vikw": "チケットは正常に解決されました",
  "CS_1_Type_kuvZ": "タイプ",
  "CS_1_Role_QhMU": "ユーザータイプ",
  "CS_one_Please_confirm_ViBj": "選択されたコンタクトリーズンを確認してから、[確定]をクリックして破棄してください。",
  "CS_2_Refund_history_NZXS": "払い戻し履歴",
  "CS_info2_Related_Worksheets_TnzD": "チケットを関連付ける（任意）",
  "CS_Page_City_XSgD": "都市",
  "CS_qa_Customer_Service_CeXF": "CSR",
  "CS_Page_Passenger_List_ajVZ": "乗客リスト",
  "CS_1_Latest_before_UTUl": "新しい順",
  "CS_5_Copy_successfully_CcCu": "コピー済み",
  "CS_1_During_Operation_xWpb": "操作日時",
  "CS_one_Please_select_IHKO": "国および営業項目を選択してください",
  "CS_one_During_Operation_JDju": "操作日時",
  "CS_qa_More_Paqa": "その他",
  "CS_info_Select_Channel_HWlg": "チャネルを選択してください",
  "CS_info2_Rider_Issuing_TDAx": "乗客の注文時間",
  "CS_4_Contact_Records_NcjV": "連絡履歴",
  "ark.global.cs.TOOL_ACTION_associated_ticket": "チケットを関連付けました",
  "Magellan_improvement_Information_Secure_LRtP": "守秘義務について",
  "CS_Page_Enter_driver_CirL": "ドライバーIDを入力",
  "CS_Page_Select_driver_rrhQ": "ドライバータイプを選択してください",
  "CS_qa_There_is_vPke": "{{inputbox}}に未送付の内容があります。このページを離れると、その内容が消去されます。本当にこのページを離れますか？",
  "CS_one_Father_classification_lZII": "親カテゴリーレベル2 (ja_JP)",
  "CS_info_Mobile_phone_SGyc": "ユーザーが見つかりません。携帯電話番号が無効か、ユーザー登録されていません。",
  "CS_one_Export_data_YQDj": "データをエクスポート",
  "CS_information_Departure_zaxW": "出発地点",
  "CS_TicketHandlingPage_This_CR_VWpW": "手動SOPはこのCRに対応済です。SOPに基づいてチケットを処理してください。",
  "CS_2_Work_Order_anVq": "チケットグループ",
  "CS_info_Select_Business_bhhu": "サービスタイプを選択してください",
  "CS_Adjustment_ZMnG_gsAL": "その他",
  "CS_information_Order_ID_vVme": "注文ID",
  "CS_one_User_Type_iRnJ": "ユーザータイプ",
  "CS_4_Order_details_ulUl": "注文の詳細",
  "CS_one_Edit_LtHm": "変更",
  "CS_info2_If_there_BivS": "（もしあれば）関連チケットを選択してください",
  "CS_Page_Billing_models_otMq": "車両タイプ",
  "CS_Page_Enter_your_kKAs": "携帯電話番号を入力してください",
  "CS_page_No_email_Uhdl": "返信する権限がありません",
  "CS_Adjustment_VZmt_VnjZ": "スキップする理由を選択してください",
  "CS_Adjustment_oVPm_qPQP": "ユーザーはオフラインか、チャットを退出しています",
  "CS_one_View_miAp": "表示",
  "CS_fits_OUZR_woGE": "注文のプロダクトライン",
  "CS_1_Compensation_deduction_pTJS": "補償/差し引きチャネル",
  "CS_info2_More_akQx": "もっと見る",
  "CS_1_Work_orders_cLNO": "IN-APPメッセージがチケットに送信されました",
  "CS_1_Roaming_wzIe": "ローミング",
  "CS_5_Copy_qVgF": "コピー",
  "CS_Page_Star_Standard_ICmt": "星評価",
  "CS_compensation_Refusal_of_hveW": "補償却下済",
  "CS_initialization_Select_Order_dqhz": "お問い合わせ対象の注文を選択",
  "CS_TicketHandlingPage_Artificial_SOP_vwXh": "手動SOP",
  "CS_Page_Passenger_Email_qveC": "乗客メールアドレス",
  "CS_Page_Between_the_eqMJ": "作成日時",
  "CS_Page_Business_Type_nsHy": "サービスタイプ",
  "CS_page_Do_you_tMFN": "このチケットをクローズしますか？",
  "CS_2_Work_Order_fABY": "チケットIDは正常にコピーされました",
  "CS_Page_Pick_up_CNzD": "乗車地点",
  "More": "その他",
  "CS_improvement_Unanswered_qcLt": "応答なし",
  "CS_1_Related_Orders_hkRo": "関連注文",
  "CS_info_Comments_successfully_YcZj": "コメント追加済み",
  "CS_tickets_Enter_the_FCWt": "ユーザー関連チケット",
  "CS_information_Booking_session_CBQY": "予定時間",
  "ark.global.cs.field.values.ticket_tab_inner_reply": "内部メッセージ",
  "CS_Page_Driver_ID_TPqW": "ID／パスポート番号",
  "CS_info_Select_Work_KXNc": "チケットグループを選択してください",
  "Help_conversations_Robot_chat_QzDc": "チャット履歴",
  "CS_tickets_Between_the_mEqx": "作成日時",
  "CS_2_Passenger_Basic_FFNN": "乗客の基本情報",
  "CS_page_Do_you_GgIB": "{{ticketgroup}}の{{handler}}にチケットを転送しますか？",
  "CS_1_Enter_text_NYGo": "ご入力ください",
  "CS_1_Compensation_ID_BGFF": "補償ID",
  "CS_1_Work_order_wyuA": "チケット情報",
  "CS_info_Select_User_rSZo": "ユーザータイプを選択してください",
  "CS_one_Classification_of_QAlG": "問い合わせ理由",
  "ark.global.cs.field.values.ticket_tab_asyc_msg": "IN-APPメッセージ",
  "CS_pop_Can_t_QjXi": "関連する入電が見つかりませんか？",
  "CS_one_You_can_MflO": "「()」「?」およびスペース以外の特殊文字を使用することはできません。",
  "ark.global.cs.field.values.ticket_tab_outer_reply": "外部返信",
  "CS_one_operator_Itcg": "オペレーター",
  "CS_one_Organization_eUqC": "組織",
  "CS_5_Comply_with_YDuq": "会社の情報セキュリティポリシーに従ってください",
  "CS_prompt_Driver_registration_mBqS": "ドライバー登録レビュータスクが見つかりません",
  "CS_Page_Order_ID_tWzK": "注文ID",
  "CS_one_Classification_of_jyqM": "コンタクトリーズン (ja_JP)",
  "CS_Page_Status_of_SBuB": "決済ステータス",
  "CS_Page_Enter_ID_IgwX": "ID／パスポート番号を入力",
  "TEXT_ERRMSG_OK": "成功しました",
  "CS_Page_Passenger_Mobile_ckjq": "乗客の携帯電話番号",
  "CS_qa_User_Tjti": "ユーザー",
  "CS_one_Classification_of_AlnN": "コンタクトリーズン (ja_JP)",
  "CS_1_Help_us_ilXL": "サービス向上へご協力ください",
  "CS_one_Are_you_eqhN": "本当に新規コンタクトリーズンを作成してよろしいですか？作成すると、新しいコンタクトリーズンが対象国で有効になります。該当する国の関連する同僚に知らせてください。",
  "CS_initialization_Select_City_uKvx": "都市を選択してください",
  "CS_pop_Bind_fsRd": "追加済み",
  "CS_2_Classification_of_QmXS": "問い合わせ理由",
  "kfcommon-fe-i18n-knowledge---knowledgeConfig.robot": "ロボット",
  "ark.global.cs.field.title.ticket_tab_log": "チケットログ",
  "CS_pop_Yes_yDMc": "はい",
  "CS_tickets_One_year_gmPi": "過去1年間",
  "CS_page_Internal_reply_pruf": "内部返信は必須入力項目です",
  "ark.global.cs.field.title.ticket_tab_info": "情報記録",
  "CS_Page_Front_ID_apqL": "バンドル詳細：バンドルID",
  "CS_1_User_Name_dhWx": "ユーザー氏名",
  "CS_one_Batch_scrap_qzlO": "バッチの破棄",
  "CS_info2__unk_RIxc": "挿入",
  "CS_Tools_colombo_tool_platform_Cancel_gNzm": "キャンセル",
  "CS_one_Parental_classification_zEhp": "親カテゴリー (ja_JP)",
  "Help_buchong_Reply_Record_dsUU": "返信履歴",
  "CS_info2_All_orders_yVmI": "過去180日以内の注文を全て表示しています",
  "CS_1_The_oldest_vXHS": "古い順",
  "CS_monitor_Each_compensation_BfxO": "補償申請はすべて記録されます。カスタマーセンターの補償ポリシーに従って申請してください。ポリシーのガイドラインに沿わない申請は内部で審査されます。",
  "comTool.channelRefundERR": "該当注文に請求書がありません。元のルートにより返金することはできません。",
  "review.auditInfo": "詳細",
  "list.orderId": "注文ID",
  "comTool.refundStatus": "返金状態",
  "common.pleaseSelect": "選択してください",
  "new.tags": "タグ",
  "comfort.vehicleModel": "車種",
  "comfort.requiredYear": "年式 >",
  "chat.save": "保存",
  "review.submitReview": "レビューのために送信",
  "new.continueHandle": "処理を続行する",
  "comTool.driverV": "ユーザータイプが乗客であるために補正できません",
  "comTool.balance": "残高",
  "automation.action": "操作",
  "list.compensatePhone": "補償番号",
  "staticConfig.false": "いいえ",
  "work.businessTypeName": "サービスタイプ",
  "new.orderInfo": "注文情報",
  "review.viewFlowchart": "フローチャートを表示",
  "comTool.riderCompensation": "乗客補填",
  "comTool.driverActualRevenue": "乗車料（ドライバーが実際徴収した金額）",
  "comTool.driverId": "ドライバーID",
  "new.knowdgeBase": "知識ベース",
  "comTool.passenger": "乗客",
  "list.channel": "チャネル",
  "clipper.clipperTitle": "関連するClipperチケットの情報",
  "comTool.reasonForCompensation": "補償理由",
  "comTool.driverPhone": "ドライバー登録電話番号",
  "review.commitTime": "送信時間",
  "common.system": "システム",
  "common.more": "詳細",
  "comTool.amountERR": "金額入力エラー",
  "staticConfig.yes": "はい",
  "staticConfig.operationSuccessfully": "成功した操作",
  "list.worksheetId": "チケットID",
  "comTool.status": "乗客支払い状況",
  "comTool.driverDeduction": "ドライバー控除",
  "new.ticketRefreshV": "作業指示情報が更新され、処理が続行されます",
  "common.jingmoThreeMonths": "最近三ヶ月以内のサイレンスログのみを表示します",
  "comTool.refundCost": "申請金額",
  "list.amount": "金額",
  "review.auditor": "レビュー担当者",
  "common.Toolbox": "ツールボックス",
  "common.ticketList": "チケットリスト",
  "comfort.city": "都道府県",
  "review.taskName": "タスクの種類",
  "staticConfig.channelSetting": "チャンネル設定",
  "comTool.detailsOfCompensation": "補填詳細",
  "clipper.clipperDetail": "関連するClipperチケットがあります。",
  "comTool.driverCompensation": "ドライバー補填",
  "review.submitReviewConfirm": "本当にこの情報をレビューのために送信しますか？",
  "new.uploadFailed": "アップロードに失敗しました。再度お試しください。",
  "comTool.operationStatus": "承認状況",
  "clipper.status": "Clipperチケットステータス",
  "review.actions": "アクション",
  "comTool.passengerCouponV": "ユーザータイプがドライバであるため補償クーポンを要求できません",
  "work.Workbench": "マイチケット",
  "comTool.cost": "乗客支払い金額（補償上限）",
  "chat.transfer": "転送",
  "chat.onlineResponse": "IN-APPメッセージ",
  "review.auditTime": "レビュー日時",
  "staticConfig.no": "いいえ",
  "staticConfig.businessTypeName": "サービスタイプ",
  "new.NullEmergencyContact": "ユーザーが緊急連絡先を設定していない",
  "new.emergencyContact": "緊急連絡先",
  "common.confirm": "確認",
  "comfort.model": "車種",
  "clipper.T3first": "Clipper T3処理開始時間 ",
  "common.abnormalReminder": "リスク警告",
  "new.editTime": "編集時間",
  "comTool.pay": "旅客財布補償",
  "review.undoChanges": "変更を元に戻す",
  "comTool.channelName": "乗客支払い方法",
  "callInfo.operation": "操作",
  "clipper.creationDate": "Clipper作成時間",
  "common.continueTocompensate": "それでも補償する",
  "comTool.coupon": "乗客補償券",
  "list.amountRange": "金額範囲",
  "comTool.channelRefund": "乗客返金",
  "clipper.ticketID": "ClipperチケットID",
  "comfort.search": "検索",
  "clipper.T2first": "Clipper T2処理開始時間",
  "new.PleaseCreateTicket": "最初にチケットを起票してください",
  "comTool.refund": "返金",
  "detail.handle": "対応する",
  "new.fileBig": "ファイルが大きすぎます。5MB以下のファイルを選択してください。",
  "create.NewTicket": "新規チケット",
  "staticConfig.true": "はい",
  "review.auditResult": "結果",
  "new.editUser": "エディタ",
  "review.modify": "編集",
  "detail.handleV": "該当チケットはすでに処理されております。操作を続けますか？",
  "new.refreshTicket": "作業指示をリフレッシュする",
  "comTool.routeOfCompensation": "補填ルート",
  "common.recommendationNotcompensate": "推奨：補償を行わない。",
  "common.to": "に変更する",
  "comTool.noOrderAll": "現在の作業指示書は注文されておらず、補償もサポートされていません。",
  "clipper.clickToView": "こちらをクリックして確認",
  "common.up": "表示しない",
  "Fleet_0303_Fleet_WorkRegime_Contents_TAuX": "No content",
  "Help_version_Business_lines_VOJX": "Category",
  "CS_Service_The_driver's_JbyZ": "Driver’s level was {{driver_level}} when this ticket was created",
  "CS_Service_Driver_Level_qpqY": "Driver Level",
  "Help_version_Enter_number_MyWJ": "Incoming Phone No.",
  "Help_version_Country_XKEj": "Country",
  "CS_page_Site_Name_dYcm": "Stop Name",
  "CS_page__unk_uZmz": "Minibus Info",
  "Help_version_Answer_DVQw": "Answer",
  "CS_page_Cancelled_xyYr": "Cancelled",
  "CS_notification_dwyv_UnUJ": "This inbound user is a fleet partner. Only Fleet tools are applicable.",
  "CS_page_Actual_arrival_YPiM": "Actual Arrival Time",
  "CS_page_This_order_jAmf": "Trip Stops",
  "CS_page_Estimated_arrival_QwhV": "Estimated Arrival Time",
  "Help_version_Telephone_entry_PGun": "Phone Bar",
  "Help_want__Change_pUeS": "More suggestions",
  "Help_version_Thread_tmgY": "Contact Reason"
}